export default "__VITE_ASSET__DgX6zsAD__"